import { render, staticRenderFns } from "./enclosure-list.vue?vue&type=template&id=613b9a9c"
import script from "./enclosure-list.vue?vue&type=script&lang=ts"
export * from "./enclosure-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports